import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import trafikArtis from "../../assets/img/traffic-up-robesnmore.png"
import sorunlar from "../../assets/img/robesnmore-right.png"
import cozum from "../../assets/img/robesnmore-left.png"
import tasarim from "../../assets/img/robesnmore-info.png"

import bilgione from "../../assets/img/robesnmore-detail.png"
import desingpc from "../../assets/img/design-pc-4.png"
import desingpctwo from "../../assets/img/design-pc-5.png"



const ReferancesDetail = () => (
    <Layout>
        <SEO title="robesNmore Başarı Hikayesi" 
        description="2019'dan itibaren dijital pazarlama hizmetleri verdiğimiz robesNmore'un başarı hikayesini okumak için tıklayın!"
        />
        <div className="referances-detail py60 container news">
            <div className="col-md-6 detail-left">
                <b>Başarı Hikayesi</b>
                
                <h1 style={{ marginTop: 20 }}>RobesNmore</h1>
                <p style={{ maxWidth: 500 }}>robesNmore, Kaliforniya'da bulunan ve havlu, bornoz ve diğer nevresimlerin ithalatı, üretimi ve toptan satışı konusunda uzmanlaşmış bir aile şirketidir. 2019'da e-ticaret mağazalarının organik trafiğini ve satışlarını artırmak için bir dijital pazarlama stratejisine yatırım yapmaya karar verdiler.</p>
                <div className="col-md-6 referances-boxs news">
               <div className="boxs" style={{ marginBottom: '0' }}>
                    <div className="box">
                        <span>+132%</span>
                        <p>Organik Oturum</p>
                    </div>
                    <div className="box">
                        <span>+44%</span>
                        <p>Yeni Kullanıcılar</p>
                    </div>
                    <div className="box">
                        <span>+22%</span>
                        <p>Alışveriş Dönüşümü</p>
                    </div>

                </div>
                </div>
                
            </div>
            <div className="col-md-6 referances-boxs">
               
                <div className="provided">
                    <h3>Verilen Hizmetler</h3>
                    <div className="provided-box news">
                        <div className="box" >
                        <Link to="/search-engine-optimization/"></Link>
                            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 100 100" >
                      <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(0 0.249)">
                        <rect id="bound" width="100" height="100" transform="translate(0 -0.249)" fill="none" />
                        <path id="Path-95" d="M11.261,69.088H73.219a4.131,4.131,0,0,1,0,8.261H7.131A4.131,4.131,0,0,1,3,73.219V7.131a4.131,4.131,0,1,1,8.261,0Z" transform="translate(9.392 9.392)" fill="#111111" />
                        <path id="Path-97" d="M14.144,40.3a4.131,4.131,0,0,1-6.027-5.65L23.607,18.132a4.131,4.131,0,0,1,5.695-.317L41.526,28.247,57.455,8.071a4.131,4.131,0,1,1,6.484,5.119L45.351,36.734a4.131,4.131,0,0,1-5.923.583L26.937,26.658Z" transform="translate(21.914 20.348)" fill="#111111" opacity="0.3" />
                      </g>
                    </svg>  
                     SEO
                        </div>
                        <div className="box" >
                        <Link to="/digital-ads/"></Link>
                            <svg id="Icons-_-Shopping-_-Cart_1" data-name="Icons-/-Shopping-/-Cart#1" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 95 95">
                      <rect id="bound" width="95" height="95" fill="none" />
                      <path id="Combined-Shape" d="M65.116,38.389,62.355,54.954l-.01.057a3.958,3.958,0,0,1-4.6,3.186l-45-8.182a3.958,3.958,0,0,1-3.1-2.807L2.419,21.928a3.958,3.958,0,0,1,3.806-5.046H60.557l2.427-10.4a4.671,4.671,0,0,1,4.548-3.609h8.173a4.671,4.671,0,1,1,0,9.341H71.239Z" transform="translate(6.707 8.493)" fill-rule="evenodd" opacity="0.3" />
                      <path id="Combined-Shape-2" data-name="Combined-Shape" d="M10.937,29.875a5.938,5.938,0,1,1,5.938-5.937A5.938,5.938,0,0,1,10.937,29.875Zm35.625,0A5.938,5.938,0,1,1,52.5,23.938,5.938,5.938,0,0,1,46.562,29.875Z" transform="translate(14.792 53.25)" fill-rule="evenodd" />
                    </svg>
                       Digital Ads
                        </div>
                        <div className="box" >
                        <Link to="/content-marketing/"></Link>
                            <svg id="katman_1" xmlns="http://www.w3.org/2000/svg" width="50" height="50" style={{fill: 999, marginLeft: 4}}  viewBox="0 0 100 100"><path id="Combined-Shape"  d="M62.41,94.64h-26.76c-1.33,0-.94,0-1.81-.01-5.49-.14-6.93-.43-10.42-1.21-7.32-1.8-12.76-5.97-16.01-12.84-2-4.25-2.54-8.82-2.69-13.45-.32-9.66-.2-19.31-.13-28.97,.03-4.05,.09-8.12,.83-12.13,1.14-6.2,3.98-11.4,9.07-15.22,4.36-3.27,9.41-4.55,14.75-4.97,2.04-.16,3.35-.25,6.11-.31,.19,0,.38-.04,.58-.04h26.3c.93,.03,.98,0,1.57,0,3.09,.04,6.13,.18,9.18,.74,7.1,1.3,12.73,4.91,16.51,11.18,2.4,3.98,3.61,8.27,3.93,12.86,.02,.55,.05,.8,.08,1.5v35.87c-.03,.56-.05,.61-.06,.93-.07,1.8-.5,3.57-.82,5.34-.96,5.33-3.17,10.02-7.17,13.77-4.71,4.42-10.47,6.15-16.75,6.62-2.23,.21-3.85,.26-6.31,.34h0Zm-13.36-8.02c2.35,0,4.69,.03,7.04,0,5.03-.06,10.09,.1,15.08-.69,6.55-1.04,11.07-4.59,13.06-11.06,.91-2.97,1.01-6.05,1.12-9.12,.27-7.89,.19-15.78,.14-23.68-.03-4.7,.02-9.4-.66-14.07-1.03-7.14-5.43-11.89-12.43-13.47-3.1-.7-6.26-.75-9.41-.81-7.76-.16-15.52-.15-23.28-.06-4.46,.05-8.92-.04-13.34,.74-6.75,1.19-11.26,5.5-12.81,12.19-.68,2.93-.74,5.92-.83,8.91-.2,7.17-.19,14.33-.12,21.5,.05,5.02-.07,10.05,.64,15.03,.66,4.61,2.59,8.52,6.52,11.23,3.03,2.09,6.5,2.81,10.09,3.05,6.39,.42,12.79,.34,19.19,.34h0Z"/><g><path id="Combined-Shape"  class="cls-1" d="M50.05,52.09c-7.47,0-14.94,0-22.41,0-2.45,0-4.07-2.15-3.33-4.37,.42-1.26,1.57-2.16,2.9-2.26,.16-.01,.33,0,.5,0h44.65c1.65,0,2.89,.81,3.39,2.17,.8,2.2-.8,4.45-3.21,4.46-4.04,.02-8.08,0-12.12,0h-10.37Z"/><path id="Combined-Shape"  class="cls-1" d="M57.4,38.8c-5.03,0-10.07,.01-15.1,0-2.37,0-3.95-2.21-3.21-4.4,.47-1.37,1.71-2.23,3.26-2.23,3.62,0,7.25,0,10.87,0,6.42,0,12.83,0,19.25,0,2.43,0,4.05,2.18,3.29,4.4-.47,1.39-1.72,2.24-3.34,2.24-5.01,0-10.01,0-15.02,0h0Z"/><path id="Combined-Shape"  class="cls-1" d="M60.92,64.87c-3.97,0-7.93,.01-11.89,0-1.87,0-3.11-2-2.53-3.98,.37-1.24,1.34-2.02,2.56-2.02,2.85,0,5.71,0,8.56,0,5.05,0,10.11,0,15.16,0,1.92,0,3.19,1.98,2.59,3.98-.37,1.25-1.36,2.02-2.63,2.02-3.94,0-7.89,0-11.83,0h0Z"/><path id="Combined-Shape"  class="cls-1" d="M33.51,58.73c1.91,0,3.81,0,5.72,0,2.02,.01,3.49,1.42,3.49,3.32s-1.48,3.31-3.49,3.32c-3.87,0-7.74,0-11.61,0-2.02,0-3.49-1.43-3.49-3.32,0-1.9,1.48-3.31,3.49-3.32,1.96,0,3.92,0,5.89,0h0Z"/><path id="Combined-Shape"  d="M28.3,39.29c-2.3,0-4.17-1.85-4.17-4.15,0-2.3,1.87-4.16,4.17-4.15,2.26,0,4.11,1.85,4.13,4.11,.02,2.3-1.84,4.18-4.13,4.19h0Z"/></g></svg>
                            İçerik Pazarlama  
                        </div>
                    </div>
                </div>
                <div className="project-details">
                    <h3>Künye</h3>
                    <div className="project-details_list">
                        <ul>
                            <li>Marka Yöneticisi:</li>
                            <li>Digital Ads:</li>
                            <li>SEO Yöneticisi:</li>
                            <li>Web Geliştiricisi</li>
                            <li>İçerik Yazarı:</li>
                        </ul>
                        <ul>
                            <li>Rana Temiz</li>
                            <li>Erman Yaman</li>
                            <li>Emel Elbeyoğlu</li>
                            <li>Serkan Sarıçiçek</li>
                            <li>Tugay Demir</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div className="container">
        <div className="text-center content news">
                <h2 style={{ marginTop: 7 }}>Doğru SEO Stratejisi Sayesinde<br/>Organik Ziyaretlerde %132 Artış</h2>
                <p style={{margin: '10px auto 0', fontWeight:600 }}>robesNmore, uyguladığımız doğru SEO stratejisi ile organik trafikte önemli bir artış yaşadı. robesNmore web sitesinin organik trafiği, 2 yıl içinde %132 oranında artış yaşadı. Hedef anahtar kelimelerin arama motoru sıralamalarında da önemli bir iyileşme yaşandı.</p>
                <p style={{margin: '10px auto 0', fontWeight:600 }}>Hedef anahtar kelimeler belirlenerek, iyi optimize edilmiş yüksek kaliteli içerikler oluşturularak ve bu içerikler içerisinde iç linkleme yapılarak web sitesi için özgün blog içerikleri üretildi.</p>
                <img className="robesnmore" src={bilgione} alt="robesnMore"/>
                <p style={{margin: '30px auto 0', fontWeight:600 }}>Üretilen ve geliştirilen içerikler sayesinde, SEO hizmetimize başladıktan sonra sayfa görüntülenmesinde %317'lik bir artış oldu.</p>
                <p style={{margin: '10px auto 0', fontWeight:600 }}>İçerik pazarlaması ve link inşası ile ilk 2 yıl içerisinde hedeflenen anahtar kelimelerde ilk sayfa hedeflerine ulaştık.</p>

            </div>
            </div>

        <div className="container">
            <div className="content-section content row py60" >
                <div className="col-md-6">
                    <img className="pr100" src={cozum} alt="robesnMore"/>
                </div>
                <div className="col-md-6">
                    <span className="small">Başarı Hikayesi</span>
                    <h3>Hedef Anahtar Kelimelerdeki Pozisyon Değişiklikleri:</h3>
                    <p style={{ maxWidth: 447, fontWeight:600}} >"Wholesale Robes" 10. sıradan 2. sıraya</p>
                    <p style={{ maxWidth: 447, fontWeight:600 }} >"Spa Robes Wholesale" 4. sıradan 3. sıraya yükseldi </p>
                    <p style={{ maxWidth: 447, fontWeight:600 }} >"Wholesale Bathrobes" 12. sıradan 3. sıraya</p>
                    <p style={{ maxWidth: 447, fontWeight:600 }} >"Waffle Robes Wholesale" 10. sıradan 1. sıraya</p>
                </div>
            </div>
            <div className="content-section content row" id="eCantaCozum">
                <div className="col-md-6">
                    <span className="small">Başarı Hikayesi</span>
                    <h3>Organik Trafik Üreten Anahtar Kelimelerde %344 Artış</h3>
                    <p style={{ maxWidth: 429, fontWeight:600 }}>Tüm bunlara ek olarak, faaliyetlerimize başladığımız günden bu yana organik trafik üreten anahtar kelime sayısını %344'lük bir artışla 900'den 4.000'e çıkarmayı başardık.</p>
                    <p style={{ maxWidth: 429, fontWeight:600 }} className="small">Ayrıca, arama motoru görünürlüğünü engelleyebilecek teknik sorunları belirlemek ve düzeltmek için web sitesinin sayfa içi denetimini gerçekleştirdik. Kırık bağlantıları düzelttik ve sitenin navigasyon yapısını kullanıcı deneyimine daha uygun olacak şekilde geliştirdik. </p>
                    <p style={{ maxWidth: 429, fontWeight:600 }} className="small">Genel olarak, robesnMore doğru SEO stratejisi ile web sitesinin organik trafiğini ve satışlarını artırmada başarılı oldu ve dijital pazarlama stratejilerinin önemli bir parçası olarak SEO operasyonlarımıza yatırım yapmaya devam ediyorlar.</p>
                </div>
                <div className="col-md-6">
                    <img src={sorunlar} alt="robesnMore"/>
                </div>
            </div>

            <div className="text-center content py60">
                <span className="small">Başarı Hikayesi</span>
                <h2 style={{ margin: '7px auto 50px', maxWidth: 1500 }}>Reklam Optimizasyonları ile Yeni Kullanıcı Sayısında %44, Alışveriş Dönüşümlerinde %22 Artış!</h2>
                
            </div>
            

            

            <div className="content-section content row" id="eCantaCozum">
            <div className="col-md-6">
                    <img src={trafikArtis} alt="iki laptop bilgisayar ekranında tcdd taşımacılık web sitesi görüntüleniyor" />
                </div>
                <div className="col-md-6">
                    <p style={{ maxWidth: 429, fontSize: 20}} className="small news">robesNmore, arama ağı reklamları sayesinde zaman içerisinde online satışlarında önemli ölçüde artış ve daha yüksek dönüşüm oranı elde etti ve bu alana yatırım yapmaya devam ediyor!  Bu yatırımın sonucunda 2 yıllık süreçte ücretli arama pazarlaması ile yeni kullanıcı kazanımında %44, alışveriş dönüşümünde %22 ve gelirde %68 artış yaşadık!</p>
                </div>
                <img src={tasarim} style={{ width: '100%', marginTop:40, marginBottom:40 }} />

            </div>

            <div className="content-section content row" id="eCantaCozum">
            
                <div className="col-md-6">
                    <p style={{ maxWidth: 500, fontSize: 20 }} className="small news">İlk olarak, markanın ürünleriyle ilgili ve yüksek aranma hacmine sahip anahtar kelimeleri belirlemek için araştırmalar yaptık ve reklam stratejisini belirlemek için sektördeki rakipleri analiz ettik.</p>
                </div>
                <div className="col-md-6">
                    <img src={desingpc} alt="iki laptop bilgisayar ekranında tcdd taşımacılık web sitesi görüntüleniyor" />
                </div>
            </div>
            <div className="content-section content row" id="eCantaCozum">
            <div className="col-md-6">
                <img src={desingpctwo} alt="iki laptop bilgisayar ekranında tcdd taşımacılık web sitesi görüntüleniyor" />
            </div>
            <div className="col-md-6">
                <p style={{ maxWidth: 500, fontSize: 20 }} className="small news">Araştırmalarımıza dayanarak, farklı kampanya setleriyle bir dizi arama ağı reklamı oluşturduk. Reklamları özellikle markamızın satış yapmayı hedeflediği belirli coğrafi konumlara ve demografik özelliklere yönelik olarak hazırladık. Rakiplerin kampanyaları analiz edildi ve karşılama sayfası, reklamı destekleyecek şekilde fiyatlandırma iletişimine vurgu yapılarak yeniden tasarlandı.</p>
            </div>
            
        </div>

        </div>


        <Checkup />
    </Layout >
)

export default ReferancesDetail
